import axios from "axios";
export const GenerateUploadURL = {
  data: () => ({}),
  methods: {
    async GenerateUploadURLMethods(key, file) {
      //   const headers = {
      //     "Content-Type": "application/json",
      //   };
      var dataInput = {
        key: key,
      };
      await axios
        .post(
          "https://ck1o4ahf2l.execute-api.us-east-1.amazonaws.com/s3_upload/get_s3_url",
          dataInput
        )
        .then((response) => {
          this.loading = false;
          if (response.status == 200) {
            this.uploadS3Method(key, response.data.message, file);
          }
        })
        .catch((Error) => {
          this.loading = false;
          console.log("Error", Error);
        });
    },

    async uploadS3Method(key, uploadURL, file) {
      try {
        const config = {
          method: "put",
          maxBodyLength: Infinity,
          url: uploadURL,
          headers: {
            "Content-Type": file.type,
          },
          data: file,
        };

        const result = await axios(config);

        if (result.status === 200 && result.statusText === "OK") {
          this.getS3FileMethod(key);
        }
      } catch (error) {
        console.log("Error uploading to S3:", error);
      }
    },
    async getS3FileMethod(key) {
      try {
        let config = {
          method: "post",
          maxBodyLength: Infinity,

          url: "https://ck1o4ahf2l.execute-api.us-east-1.amazonaws.com/s3_download/get_s3_file",
          data: { key: key },
        };
        let result = await axios(config);
        if (result.data.status === "Success") {
          console.log("result", result);
          this.imgSrc = result.data.message;
        }
      } catch (error) {
        console.log("Err", error);
      }
    },
  },
};
